type UseCookies = {
    getCookie: (key: string) => string | null;
    setCookie: (key: string, value: string, domain?: string) => void;
};

export function useCookies(): UseCookies {
    const getCookie = (name: string): string | null => {
        if (typeof document === 'undefined') {
            return null;
        }
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) {
                return decodeURIComponent(value);
            }
        }
        return null;
    };
    const setCookie = (key: string, value: string, domain?: string): void => {
        let cookie = `${encodeURIComponent(key)}=${encodeURIComponent(value)}; path=/`;
        if (domain) {
            cookie += `; domain=${domain}`;
        }
        // Required for cross-subdomain cookies on HTTPS
        cookie += '; Secure; SameSite=None';
        document.cookie = cookie;
    };

    return { getCookie, setCookie };
}
